import { registerSW, readySW } from "./sw-register";

function isStandalone() {
    if (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) return true;
    if ("standalone" in navigator && navigator.standalone) return true;
    return false;
}

async function askPermission() {
    if (!("Notification" in window)) return "denied";
    if (Notification.permission !== "default") return Notification.permission;
    try { return await Notification.requestPermission(); } catch { return "denied"; }
}

async function enableNow(testNotify) {
    await registerSW();
    const perm = await askPermission();
    if (perm !== "granted") return false;
    const reg = await readySW();
    if (testNotify && reg?.showNotification) {
        try {
            await reg.showNotification("Dodávkáři", {
                body: "Notifikace povoleny.",
                icon: "/icons/icon-192.png",
                badge: "/icons/badge-72.png",
                tag: "dk-notif-ready"
            });
        } catch {}
    }
    return true;
}

export function initNotifications(opts = {}) {
    const key = "dk_notif_prompted_at";
    const now = Date.now();
    const cooldown = 1000 * 60 * 60 * 12;
    const last = parseInt(localStorage.getItem(key) || "0", 10);
    if (Notification?.permission === "granted") { registerSW(); return; }
    if (Notification?.permission === "denied") return;
    if (!("Notification" in window)) return;
    if (last && now - last < cooldown) return;

    const handler = async () => {
        window.removeEventListener("pointerdown", handler);
        window.removeEventListener("keydown", handler);
        localStorage.setItem(key, String(Date.now()));
        await enableNow(opts.testNotification === true);
    };

    window.addEventListener("pointerdown", handler, { once: true, passive: true });
    window.addEventListener("keydown", handler, { once: true });

    if (isStandalone()) {
        setTimeout(() => {
            if (Notification.permission === "default") {
                const evt = new Event("pointerdown");
                window.dispatchEvent(evt);
            }
        }, 800);
    }
}
